import { Html } from '../types'

export const createHtmlObject = (value: string | null): Html => ({
  value,
  $type: 'html',
})
